import { render, staticRenderFns } from "./RecordEditHistory.vue?vue&type=template&id=36ad04a1&scoped=true"
import script from "./RecordEditHistory.vue?vue&type=script&lang=js"
export * from "./RecordEditHistory.vue?vue&type=script&lang=js"
import style0 from "./RecordEditHistory.vue?vue&type=style&index=0&id=36ad04a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad04a1",
  null
  
)

export default component.exports